import React, { useContext, useEffect, useMemo, useState } from 'react';
import { CrLoadingOverlay } from '../cr/CrLoadingOverlay';
import styles from '../../styles/cr.module.scss';
import axios from 'axios';
import { DataContext } from '../DataContext';
import { UserAppLaunchLog } from '../../types';
import { AppGlobals, AppIDs } from '../../AppGlobals';
import { AppWelcomeButtons } from '../AppWelcomeButtons';
import { useHistory } from 'react-router-dom';
import { GraphRenderer } from '../charts/GraphRenderer';

interface CloeAIWelcomeProps {
}

interface IAppWelcomeText {
    CenteralHeading: string;
    CenteralBody: string;
    CustomerWelcomeHeading: string;
    CustomerWelcomeBody: string;
}

export const CloeAIWelcome: React.FC<CloeAIWelcomeProps> = () => {
    const { dataServices } = useContext(DataContext);
    const history = useHistory();
    const [formData, setFormData] = useState<IAppWelcomeText>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [isGraphDataAvailable, setIsGraphDataAvailable] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                const zedxNetapiURL = process.env.REACT_APP_ZedX_Net_API!;
                const zedxNetWelcomeTextApi = `${zedxNetapiURL}/availableapps/GetAppWelcomeText/CLOEAI/${AppGlobals.CustomerRef}`;

                const centeralWelcomeText = (await axios.get(zedxNetWelcomeTextApi)).data;

                setFormData({
                    CenteralHeading: centeralWelcomeText.WelcomeHeading,
                    CenteralBody: centeralWelcomeText.WelcomeBody,
                    CustomerWelcomeHeading: '',
                    CustomerWelcomeBody: ''
                });

                dataServices.userAppLaunchLogService.create(
                    new UserAppLaunchLog(AppIDs.CLOEAI)
                );

                setLoading(false);
            } catch (error) {
                console.error('Error loading entity:', error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const formattedCenteralBody = useMemo(() => {
        if (!formData) return '';
        return formData.CenteralBody
            ? formData.CenteralBody.replace(/\n/g, '<br>')
            : '';
    }, [formData]);

    const formattedCustomerBody = useMemo(() => {
        if (!formData) return '';
        return formData.CustomerWelcomeBody
            ? formData.CustomerWelcomeBody.replace(/\n/g, '<br>')
            : '';
    }, [formData]);

    const handleTopicsClick = () => {
        history.push('/a14/topics');
    };

    const handleChatsClick = () => {
        history.push('/a14/chats');
    };

    return (
        <div
            style={{ maxWidth: '1200px', position: 'relative' }}
            className={styles.cr}
        >
            <CrLoadingOverlay isLoading={loading} opaque={true} />

            {formData && (
                <>
                    <h1
                        style={{ textAlign: 'center', marginLeft: '20px' }}
                        className={styles.welcomeL1Heading}
                    >
                        {formData.CenteralHeading}
                    </h1>

                    <div className="welcomePage-container">
                        <div className="welcomePage-leftDiv">
                            <div>
                                <div
                                    className={styles.welcomeBody}
                                    dangerouslySetInnerHTML={{
                                        __html: formattedCenteralBody
                                    }}
                                />
                            </div>

                            <div>
                                {formData.CustomerWelcomeHeading?.length > 0 && (
                                    <div
                                        style={{
                                            fontWeight: 'bold',
                                            textDecoration: 'underline'
                                        }}
                                        className={styles.welcomeBody}
                                    >
                                        {formData.CustomerWelcomeHeading}
                                    </div>
                                )}
                            </div>

                            <div>
                                {formattedCustomerBody?.length > 0 && (
                                    <div
                                        className={styles.welcomeBody}
                                        dangerouslySetInnerHTML={{
                                            __html: formattedCustomerBody
                                        }}
                                    />
                                )}
                            </div>

                            <br />

                            <AppWelcomeButtons
                                updatesButtonText="Topics"
                                updatesButtonStyle={{ minWidth: '150px' }}
                                onUpdatesClick={handleTopicsClick}
                                insightsButtonText="Chats"
                                insightsButtonStyle={{ minWidth: '150px' }}
                                onInsightsClick={handleChatsClick}
                            />
                        </div>

                        <div className="welcomePage-rightDiv">
                            {/* {isGraphDataAvailable && (
                                <div className="welcomePage-chartHeading">
                                    AI usage across your organisation
                                </div>
                            )} */}

                            <GraphRenderer
                                graphShortname="CloeAIWelcomeDonutChart"
                                onGraphDataFetch={(dataAvailable) =>
                                    setIsGraphDataAvailable(dataAvailable)
                                }
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};